export function isNotNull(value: any): boolean {
    return !value;
}